import { Dialog, DialogContent } from "@/components/ui/dialog";
import { AdvancedSearchPanel } from "./AdvancedSearchPanel";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

interface AdvancedSearchModalProps {
	isOpen: boolean;
	onClose: () => void;
	jobId: string | undefined;
	jobSkills?: string[];
	onAddMatches?: (matches: any[]) => void;
}

export function AdvancedSearchModal({
	isOpen,
	onClose,
	jobId,
	onAddMatches,
}: AdvancedSearchModalProps) {
	const { t } = useTranslation();
	const matchesAddedRef = useRef(false);

	useEffect(() => {
		if (isOpen) {
			matchesAddedRef.current = false;
		}
	}, [isOpen]);

	if (!jobId) return null;

	const handleClose = () => {
		onClose();
		if (matchesAddedRef.current) {
			window.location.reload();
		}
	};

	const handleAddMatches = (matches: any[]) => {
		matchesAddedRef.current = true;
		if (onAddMatches) {
			onAddMatches(matches);
		}
	};

	return (
		<Dialog open={isOpen} onOpenChange={() => handleClose()}>
			<DialogContent className="w-[98vw] max-w-[1400px] h-[90vh] flex flex-col overflow-hidden p-6">
				<AdvancedSearchPanel
					jobId={jobId}
					onAddMatches={handleAddMatches}
					onClose={handleClose}
				/>
			</DialogContent>
		</Dialog>
	);
}
